// extracted by mini-css-extract-plugin
export default {"resultsHeaderTitle":"kWmVvo","headingGap":"z4HCV9","offsetTitle":"Mg7ZM0"};